import {CTA, styled} from '@volkswagen-onehub/components-core'
import React from 'react'
import {useTranslation} from 'react-i18next'
import {useDispatch, useSelector} from 'react-redux'
import {
    setSelectedCarModelTypes,
    setSelectedCarNames,
    setSelectedCarTypes,
    setSelectedEngineTypes,
} from '../../../features/general/generalSlice'
import TrackingAction from '../../../tracking-manager'
import SingleModelInterface from '../../../types/singleModelInterface'
import {useFeatureServices} from '../../../use-feature-services'
import {getFilterResetClickData} from '../../../utils/tracking/getTrackingData'
import setTracking, {
    checkTrackingManager,
} from '../../../utils/tracking/tracking-utils/setTracking'
import {RootState} from '../../rootReducer'
import {setUrlParams} from '../../../utils/url/setUrlParams'
import {Params} from '../../../shared/variables'
import {clearHashFromUrl} from '../../../utils/url/hashParams'

const FiltersTextContainer = styled.div`
    display: flex;
    align-items: center;
    margin-top: 40px;
`

const FiltersText = styled.p`
    margin: 0;
    margin-right: 10px;
`

export interface ResetFiltersProps {
    filteredCars: SingleModelInterface[]
    trackingBrandLabel: string
    isShowroomMode: boolean
    carTypes: string[]
    engineTypes: string[]
    translatedEngines: string[]
    modelFilteredByDealer: SingleModelInterface[]
}

export default function ResetFilters(
    props: ResetFiltersProps
): React.JSX.Element {
    const {t} = useTranslation('app')
    const {tracking: trackingManager} = useFeatureServices()
    const dispatch = useDispatch()
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const {'s2:history': historyService} = useFeatureServices() as any

    const totalModels = useSelector(
        (state: RootState) => state.general.numberOfModelsWithActivePromotions
    )
    const dealerCode = useSelector(
        (state: RootState) => state.dealerData.dealerCode
    )

    const totalModelsFilteredByDealer =
        dealerCode !== '' ? props.modelFilteredByDealer.length : totalModels

    function resetFiltersOnClick(): void {
        clearHashFromUrl(historyService)

        dispatch(setSelectedCarTypes([]))
        dispatch(setSelectedEngineTypes([]))
        dispatch(setSelectedCarNames([]))
        dispatch(setSelectedCarModelTypes([]))

        setUrlParams(historyService, `${Params.CATEGORIES}-app`, '')
        setUrlParams(historyService, `${Params.FUELS}-app`, '')
        setUrlParams(historyService, `${Params.MODELS}-app`, '')

        if (checkTrackingManager(trackingManager)) {
            setTracking(
                trackingManager,
                TrackingAction.VWBasic_FilterReset_Click,
                getFilterResetClickData(
                    t('filters.resetFilters'),
                    totalModelsFilteredByDealer,
                    props.trackingBrandLabel,
                    [
                        {
                            type: 'multi_value',
                            name: 'CA',
                            values: [t('filters.carType')],
                        },
                        {
                            type: 'multi_value',
                            name: 'FT',
                            values: [t('filters.engineType')],
                        },
                    ],
                    props.isShowroomMode
                )
            )
        }
    }

    return (
        <FiltersTextContainer>
            <FiltersText
                dangerouslySetInnerHTML={{
                    __html: t('filters.shownModels', {
                        count: props.filteredCars.length,
                        total: totalModelsFilteredByDealer,
                    }),
                }}
            />

            <CTA
                onClick={() => resetFiltersOnClick()}
                tag="button"
                emphasis="tertiary"
                aria-label={t('filters.resetFilters')}
            >
                <span
                    dangerouslySetInnerHTML={{
                        __html: t('filters.resetFilters'),
                    }}
                />
            </CTA>
        </FiltersTextContainer>
    )
}
